"use client";

import React, {useEffect, useState} from "react";
import Image from "next/image";
import ElanzaLogoMobile from "@/public/logo/elanza-logo-mobile.svg";
import MobileMenu from "@/components/ui/menu/mobile-menu/mobile-menu";
import MobileMenuSearchResult from "@/components/ui/menu/mobile-menu/component/mobile-menu-search-result";
import TopBarComponent from "@/components/ui/top-bar/topBarComponent";
import {usePathname} from "next/navigation";
import Link from "next/link";
import HeaderQueryHooks from "@/http/api/header/HeaderQueryHooks";
import {Loader2} from "lucide-react";

const {useHeaderCategory} = new HeaderQueryHooks()

function MobileHeaderComponent({
                                   topBarStatus,
                                   textColor,
                                   text,
                                   bgColor,
                                   hrefURl,
                                   backgroundImagePath
                               }: any) {


    const {data, isPending} = useHeaderCategory()

    const categoriesProductCount = data?.data?.categoriesProductCount


    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const pathname = usePathname()

    if (pathname.includes("/auth") || pathname.includes("/profile")) return null


    return (
        <section className={`${topBarStatus && "h-16"} md:h-0`}>
            <div className={"fixed top-0 w-full right-0 z-20 mb-10"}>
                {topBarStatus === "on" &&
                    <TopBarComponent text={text} bgColor={bgColor} textColor={textColor} hrefURl={hrefURl}
                                     backgroundImagePath={backgroundImagePath}/>}
            </div>
            <header
                className={`w-full fixed bg-white z-50 duration-300 flex md:hidden h-14 flex-wrap items-center justify-between px-[23px] border-b ${
                    topBarStatus === "on" ? (isScrolled ? "top-12" : "top-[50px]") : "top-0"
                }`}
            >
                <div className="w-1/4 flex items-center justify-start">
                    {!isPending ? <MobileMenu categoriesProductCount={categoriesProductCount} data={data?.data}/> : <Loader2 className={"animate-spin"}/>}
                </div>
                <Link href={"/"} prefetch={false} className="w-2/4 flex md:hidden items-center justify-center">
                    <Image
                        priority
                        src={ElanzaLogoMobile}
                        alt={"elanza-logo"}
                        title={"elanza-logo"}
                        width={166}
                        height={21}
                    />
                </Link>
                <div className="w-1/4 flex items-center justify-end">
                    <MobileMenuSearchResult/>
                </div>
            </header>
        </section>
    );
}

export default React.memo(MobileHeaderComponent);
MobileHeaderComponent.displayName = "MobileHeaderComponent";
